/**
 * Склонение существительных по числу (русский).
 * pluralRu(82, 'позиция', 'позиции', 'позиций') → 'позиции'
 */
export function pluralRu(count, one, few, many) {
  const n = Math.abs(Number(count)) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return many;
  if (n1 > 1 && n1 < 5) return few;
  if (n1 === 1) return one;
  return many;
}

export function positionsLabel(count) {
  return pluralRu(count, 'позиция', 'позиции', 'позиций');
}

export function piecesLabel(count) {
  return pluralRu(count, 'штука', 'штуки', 'штук');
}

export function bookingsLabel(count) {
  return pluralRu(count, 'бронь', 'брони', 'броней');
}

export function bookingRecordsLabel(count) {
  return pluralRu(count, 'бронирование', 'бронирования', 'бронирований');
}
